module.exports = __webpack_public_path__ + "img/waistline_pocket_position.bac9f6dd.png";